// Single source of truth for personal info. Update here, not in components.
export const profile = {
  name: "Paulo Drefahl",
  roles: ["Network Engineer", "Full Stack Developer", "Published Researcher"],
  location: "Orlando, FL, USA",
  email: "phmocelin@gmail.com",
  phone: "239-738-3685",
  university: "FGCU",
  openToRelocate: "Yes",
  contactPrefill: {
    subject: "Contacting You",
    body: "Hello Paulo,\n\nI would like to discuss...",
  },
};

export const socialLinks = [
  { id: "github", href: "https://github.com/PauloDrefahl" },
  { id: "linkedin", href: "https://www.linkedin.com/in/paulodrefahl" },
  { id: "facebook", href: "https://www.facebook.com/paulo.drefahl/" },
  { id: "instagram", href: "https://www.instagram.com/paulodrefahl/" },
  { id: "leetcode", href: "https://leetcode.com/u/PauloDrefahl/" },
  { id: "mail", href: "mailto:phmocelin@gmail.com" },
];
